<template>
  <div id="TCaptcha" style="position: absolute; z-index: 1000; margin-top: 5px; box-shadow:0px 0px 6px 0px rgba(0, 0, 0, 0.25); background: #fff;">
  </div>
</template>

<script>

  export default {
    props:['mobile'],

    data(){
      return{

      }
    },

    methods:{
      //生成验证滑块功能
      async createCaptcha() {
        let _this = this

        try {
          let result = await this.apiData("get", "user/getCaptcha", {
            mobile: this.mobile
          }, undefined, true);

          let script = document.createElement('script');
          script.src = result.data.url;
          document.getElementsByTagName('body')[0].appendChild(script);
          let oDIv = document.getElementById('TCaptcha')
          script.onload = function () {
            oDIv.innerHTML = '';
            _this.latestCallbackVersion = Date.now();
            capInit(oDIv, {
              callback: createFn(_this.latestCallbackVersion),
              type: 'embed',
              width: '100%'
            });
          }
        } catch (error) {
          this.$message.error(this.errorCode[error.error_code]);
        }

        // 每次生成滑动验证码都会capInit，导致滑动结束会调多次回调
        // 以下方法解决该问题，只会调最后一次
        function createFn(v) {
          let fn = function (res) {
            if (res.ret === 0 && v === _this.latestCallbackVersion) {
              _this.$emit('on-captcha-success', res.ticket)
            }
          }
          fn.version = v;

          return fn;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/global/verifyWrap.vue